import { ArrowRightAlt } from '@mui/icons-material'
import makeStyles from '@mui/styles/makeStyles'
import { colors } from '@global/constants'

const useStyles = makeStyles(() => ({
  commitMessage: {
    marginBottom: 16,
    fontStyle: 'italic',
    color: colors.gray.medium,
    fontSize: 12,
  },
  titleText: {
    fontWeight: 'bold',
    marginBottom: 8,
  },
  pill: {
    borderRadius: '6px',
    padding: '3px 8px',
    fontSize: 12,
    lineHeight: '16px',
    minHeight: 20,
    display: 'inline-block',
    background: colors.gray.light,
    border: `1px solid ${colors.gray.main}`,
    verticalAlign: 'middle',
    marginBottom: 8,
    wordBreak: 'break-word',
  },
  strikeThrough: {
    textDecoration: 'line-through',
  },
  pillGreen: {
    background: colors.green.light,
  },
}))

export function DiffMessage({ diff }) {
  if (!diff) {
    return <></>
  }

  const { cellDiff, commit } = diff
  const isAddition = cellDiff.changeType === 'ADDITION'
  const titleText = isAddition ? 'Added' : 'Updated'
  const hasStartPill = !isAddition
  const classes = useStyles()

  return (
    <>
      <div className={classes.commitMessage}>{commit.message}</div>
      <div className={classes.titleText}>{titleText}</div>
      <div>
        {hasStartPill && (
          <>
            <div className={`${classes.pill} ${classes.strikeThrough}`}>{cellDiff.oldValue}</div>
            <ArrowRightAlt style={{ verticalAlign: 'middle', marginBottom: 8 }} />
          </>
        )}
        <div className={`${classes.pill} ${isAddition ? classes.pillGreen : ''}`}>
          {cellDiff.newValue}
        </div>
      </div>
    </>
  )
}
